import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Util } from '@/utils/utils';
import { Remote } from '@/api/remote';
import { Constants } from '@/constants/constants';
import { ApiConstant } from '@/constants/api_constants';
import { NAV_PATH } from '@/router/constants';
import { IEventList } from '@/pages/customer-support/event/interface/event.interface';

const EVENT_ONGOING_PAGE_SIZE = 9;
const EVENT_ENDED_PAGE_SIZE = 9;
const eventOnGoingPagenationLen = 10;
const eventEndedPagenationLen = 10;

const useEvent = () => {
	const navigate = useNavigate();
	let eventOnGoingCurrentPage = 1;
	let eventOnGoingTotalCnt = 1;
	let eventOnGoingTotalPage = 1;
	let eventOnGoingCurrentPageGroup = 1;
	let eventOnGoingTotalPageGroup = 1;
	let eventEndedCurrentPage = 1;
	let eventEndedTotalCnt = 1;
	let eventEndedTotalPage = 1;
	let eventEndedCurrentPageGroup = 1;
	let eventEndedTotalPageGroup = 1;

	const eventInit = () => {
		eventGetParams();
	};
	const eventGetParams = () => {
		const params = Util.getUrlParameter();
		const oPage = Util.isNullOrEmpty(params.oPage) ? '1' : String(params.oPage);
		const ePage = Util.isNullOrEmpty(params.ePage) ? '1' : String(params.ePage);

		eventOnGoingCurrentPage = parseInt(oPage, 10);
		eventEndedCurrentPage = parseInt(ePage, 10);
		eventGetData();
	};

	// 진행중인 이벤트 리스트 엘리먼트 생성
	const eventSetOnGoingListEle = (list: IEventList[]) => {
		if (list.length === 0) {
			eventNodataOnGoing();
			return;
		}

		// ul 요소에서 data-template 속성 가져오기
		const boardListCon = document.querySelector('.event .js-ongoing .card-list') as HTMLElement | null;
		if (!boardListCon) {
			return;
		}

		const template = boardListCon.getAttribute('data-template');
		if (!template) {
			return;
		}

		const len = list.length;
		let ele = '';
		for (let i = 0; i < len; i++) {
			const item = template
				.replace('<!-- title -->', list[i]?.evntTitl || '')
				.replace('<!-- desc -->', list[i]?.evntSubTitl || '')
				.replace('<!-- 시작일 -->', Util.convertDate(list[i]?.aplyStDt, '.') || '')
				.replace(
					'<!-- 종료일 -->',
					list[i]?.aplyEdDt === '99991231' ? '별도 고지시' : Util.convertDate(list[i]?.aplyEdDt, '.')
				);

			ele += item;
		}

		boardListCon.innerHTML = ele;
		eventSetOnGoingList(list);
	};

	const eventSetOnGoingList = (list: IEventList[]) => {
		const len = list.length;
		const listEle = document.querySelectorAll('.event .js-ongoing .card-list li') as NodeListOf<HTMLElement>;
		if (listEle.length === 0) return;
		for (let i = 0; i < Math.min(len, listEle.length); i++) {
			const listItem = listEle[i];

			if (!listItem) continue;

			listItem.dataset.evntId = list[i]?.evntId || '';
			const cardThumbnail = listItem.querySelector('.card-thumbnail');
			if (cardThumbnail) cardThumbnail.innerHTML = list[i]?.evntBnnr || '';

			const title = listItem.querySelector('.card-info .title');
			if (title) title.innerHTML = list[i]?.evntTitl || '';

			const desc = listItem.querySelector('.card-info .desc');
			if (desc) desc.innerHTML = list[i]?.evntSubTitl || '';

			const stDt = listItem.querySelector('.card-info .js-event-stDt');
			if (stDt) stDt.innerHTML = Util.convertDate(list[i]?.aplyStDt, '.') || '';

			const edDt = listItem.querySelector('.card-info .js-event-edDt');
			if (edDt) {
				edDt.innerHTML = list[i]?.aplyEdDt === '99991231' ? '별도 고지시' : Util.convertDate(list[i]?.aplyEdDt, '.');
			}

			listItem.addEventListener('click', eventClickOnGoingList);
		}

		eventOnGoingSetPagenation();
	};
	// 진행중인 이벤트 리스트 클릭시
	const eventClickOnGoingList = (e: MouseEvent) => {
		const evntId = (e.currentTarget as HTMLElement).dataset.evntId;
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}?evntId=${evntId}&endYn=N`);
	};

	// 종료된 이벤트 리스트 엘리먼트 생성
	const eventSetEndedListEle = (list: IEventList[]) => {
		if (list.length === 0) {
			eventNodataEnded();
			return;
		}

		// ul 요소에서 data-template 속성 가져오기
		const boardListCon = document.querySelector('.event .js-ended .card-list') as HTMLElement | null;
		if (!boardListCon) {
			return;
		}

		const template = boardListCon.getAttribute('data-template');
		if (!template) {
			return;
		}

		const len = list.length;
		let ele = '';
		for (let i = 0; i < len; i++) {
			// 데이터 삽입
			const item = template
				.replace('<!-- title -->', list[i]?.evntTitl || '')
				.replace('<!-- desc -->', list[i]?.evntSubTitl || '')
				.replace('<!-- 시작일 -->', Util.convertDate(list[i]?.aplyStDt, '.') || '')
				.replace(
					'<!-- 종료일 -->',
					list[i]?.aplyEdDt === '99991231' ? '별도 고지시' : Util.convertDate(list[i]?.aplyEdDt, '.')
				);

			ele += item;
		}

		boardListCon.innerHTML = ele;
		eventSetEndedList(list);
	};
	const eventSetEndedList = (list: IEventList[]) => {
		const len = list.length;
		const listEle = document.querySelectorAll('.event .js-ended .card-list li') as NodeListOf<HTMLElement>;
		for (let i = 0; i < Math.min(len, listEle.length); i++) {
			const listItem = listEle[i];

			if (!listItem) continue;

			listItem.dataset.evntId = list[i]?.evntId || '';
			const thumbnail = listItem.querySelector('.card-thumbnail');
			const title = listItem.querySelector('.card-info .title');
			const desc = listItem.querySelector('.card-info .desc');
			const stDt = listItem.querySelector('.card-info .js-event-stDt');
			const edDt = listItem.querySelector('.card-info .js-event-edDt');

			if (thumbnail) thumbnail.innerHTML = list[i]?.evntBnnr || '';
			if (title) title.innerHTML = list[i]?.evntTitl || '';
			if (desc) desc.innerHTML = list[i]?.evntSubTitl || '';
			if (stDt) stDt.innerHTML = Util.convertDate(list[i]?.aplyStDt, '.') || '';
			if (edDt) {
				edDt.innerHTML = list[i]?.aplyEdDt === '99991231' ? '별도 고지시' : Util.convertDate(list[i]?.aplyEdDt, '.');
			}

			listItem.addEventListener('click', eventClickEndedList);
		}

		eventEndedSetPagenation();
	};
	// 종료된 이벤트 리스트 클릭시
	const eventClickEndedList = (e: MouseEvent) => {
		const evntId = (e.currentTarget as HTMLElement).dataset.evntId;
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}?evntId=${evntId}&endYn=Y`);
	};

	// 종료된 이벤트가 없을 경우
	const eventNodataOnGoing = () => {
		const ongoingElement = document.querySelector('.js-ongoing') as HTMLElement | null;
		const paginationElement = document.querySelector('.js-ongoing .board-pagination') as HTMLElement | null;

		if (ongoingElement) {
			ongoingElement.classList.add('nodata');
		}

		if (paginationElement) {
			paginationElement.classList.add('hidden');
		}
	};
	// 종료된 이벤트가 없을 경우
	const eventNodataEnded = () => {
		const endedElement = document.querySelector('.js-ended') as HTMLElement | null;
		const paginationElement = document.querySelector('.js-ended .board-pagination') as HTMLElement | null;

		if (endedElement) {
			endedElement.classList.add('nodata');
		}

		if (paginationElement) {
			paginationElement.classList.add('hidden');
		}
	};

	const eventGetData = async () => {
		const jsonData = {
			onGoingPage: eventOnGoingCurrentPage,
			onGoingSize: EVENT_ONGOING_PAGE_SIZE,
			endedPage: eventEndedCurrentPage,
			endedSize: EVENT_ENDED_PAGE_SIZE
		};
		const response = await Remote.Api.get(ApiConstant.mgmtEvent.list, jsonData);

		if (response.code !== Constants.apiSuccess) {
			alert(response.message);
			return;
		}

		eventOnGoingTotalCnt = response.content.onGoingEvntCnt;
		eventOnGoingTotalPage = Math.ceil(response.content.onGoingEvntCnt / EVENT_ONGOING_PAGE_SIZE);

		eventEndedTotalCnt = response.content.endedEvntCnt;
		eventEndedTotalPage = Math.ceil(response.content.endedEvntCnt / EVENT_ONGOING_PAGE_SIZE);

		eventSetOnGoingListEle(response.content.onGoingEvntList);
		eventSetEndedListEle(response.content.endedEvntList);

		eventShowContents();
	};

	/**
	 * 진행중 이벤트 페이징
	 */
	const eventOnGoingSetPagenation = () => {
		const len = eventOnGoingPagenationLen;
		const targetBtn = document.querySelectorAll('.js-ongoing .pagination-btn') as NodeListOf<HTMLElement>;

		const currentPage = eventOnGoingCurrentPage;
		const totalPage = eventOnGoingTotalPage;
		eventOnGoingCurrentPageGroup = Math.ceil(currentPage / eventOnGoingPagenationLen);
		eventOnGoingTotalPageGroup = Math.ceil(totalPage / eventOnGoingPagenationLen);

		const start = (eventOnGoingCurrentPageGroup - 1) * eventOnGoingPagenationLen;
		let end = eventOnGoingCurrentPageGroup * eventOnGoingPagenationLen;
		const lastPagenationNum = eventOnGoingPagenationLen * eventOnGoingTotalPageGroup - eventOnGoingTotalPage;

		if (eventOnGoingCurrentPageGroup == eventOnGoingTotalPageGroup) {
			end = totalPage;
		}

		for (let i = 0; i < len; i++) {
			const page = start + i + 1;
			const button = targetBtn[i + 1];

			if (!button) continue; // 버튼이 null인 경우 스킵
			button.innerText = String(page); // innerText 설정 시 문자열 변환

			// 현재 페이지 활성화
			if (currentPage - (eventOnGoingCurrentPageGroup - 1) * eventOnGoingPagenationLen === i + 1) {
				button.classList.add('active');
			}

			// 마지막 페이지 그룹
			if (eventOnGoingCurrentPageGroup === eventOnGoingTotalPageGroup) {
				if (i >= len - lastPagenationNum) {
					button.classList.add('hidden');
				}
			}

			button.addEventListener('click', eventOnGoingClickPagenation);
		}

		const prevButton = document.querySelector('.js-ongoing .pagination-btn.btn-prev') as HTMLElement | null;
		const nextButton = document.querySelector('.js-ongoing .pagination-btn.btn-next') as HTMLElement | null;

		if (prevButton) {
			prevButton.addEventListener('click', eventOnGoingClickPagePrev);
		}

		if (nextButton) {
			nextButton.addEventListener('click', eventOnGoingClickPageNext);
		}
		eventOnGoingCheckBtnPrevNext(eventOnGoingCurrentPageGroup, eventOnGoingTotalPageGroup);
	};

	// 이전 버튼 클릭
	const eventOnGoingClickPagePrev = (e: MouseEvent) => {
		let pageGroup = eventOnGoingCurrentPageGroup - 1;
		if (pageGroup < 1) {
			pageGroup = 1;
		}
		eventOnGoingCurrentPageGroup = pageGroup;
		const page = eventOnGoingGetCurrentPage(
			eventOnGoingCurrentPageGroup,
			eventOnGoingTotalPageGroup,
			eventOnGoingTotalPage,
			false
		);
		eventOnGoingChangePage(page);
	};

	// 다음 버튼 클릭
	const eventOnGoingClickPageNext = (e: MouseEvent) => {
		let pageGroup = eventOnGoingCurrentPageGroup + 1;
		if (pageGroup > eventOnGoingTotalPageGroup) {
			pageGroup = eventOnGoingTotalPageGroup;
		}
		eventOnGoingCurrentPageGroup = pageGroup;
		const page = eventOnGoingGetCurrentPage(
			eventOnGoingCurrentPageGroup,
			eventOnGoingTotalPageGroup,
			eventOnGoingTotalPage,
			true
		);
		eventOnGoingChangePage(page);
	};

	// 페이지네이션 클릭
	const eventOnGoingClickPagenation = (e: MouseEvent) => {
		const page = (e.currentTarget as HTMLElement).innerText;
		eventOnGoingChangePage(page);
	};

	// 페이지 변경
	const eventOnGoingChangePage = (page: number | string) => {
		const oPage = page;
		const ePage = eventEndedCurrentPage;
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT}?oPage=${oPage}&ePage=${ePage}`);
	};

	// 이전 다음 버튼 활성 비활성 체크
	const eventOnGoingCheckBtnPrevNext = (currentPageGroup: number, totalPageGroup: number) => {
		const targetPrev = document.querySelector('.js-ongoing .pagination-btn.btn-prev');
		const targetNext = document.querySelector('.js-ongoing .pagination-btn.btn-next');

		// 이전 버튼
		if (currentPageGroup == 1) {
			eventOnGoingDisabledPagePrevNext(targetPrev);
		} else {
			eventOnGoingEnabledPagePrevNext(targetPrev);
		}

		// 다음 버튼
		if (currentPageGroup == totalPageGroup) {
			eventOnGoingDisabledPagePrevNext(targetNext);
		} else {
			eventOnGoingEnabledPagePrevNext(targetNext);
		}
	};

	// 이전 or 다음 버튼 활성화
	const eventOnGoingEnabledPagePrevNext = (target: Element | null) => {
		target?.removeAttribute('disabled');
	};

	// 이전 or 다음 버튼 비활성화
	const eventOnGoingDisabledPagePrevNext = (target: Element | null) => {
		target?.setAttribute('disabled', '');
	};

	// 페이지네이션 비활성화
	// const eventOnGoingDisabledPagenation = (target: Element | null) => {};

	const eventOnGoingGetCurrentPage = (
		currentPageGroup: number,
		totalPageGroup: number,
		totalPage: number,
		isNext: boolean
	) => {
		const len = eventOnGoingPagenationLen;
		const start = (currentPageGroup - 1) * eventOnGoingPagenationLen;
		let end = currentPageGroup * eventOnGoingPagenationLen;
		let lastPage = 0;

		if (currentPageGroup == totalPageGroup) {
			end = totalPage;
		}

		for (let i = 0; i < len; i++) {
			const page = start + i + 1;
			if (page <= end) {
				lastPage = page;
			}
		}

		const currentPage = isNext || isNext == undefined ? start + 1 : start + 1;
		return currentPage;
	};

	/**
	 * 종료된 이벤트 페이징
	 */
	const eventEndedSetPagenation = () => {
		const len = eventEndedPagenationLen;
		const targetBtn = document.querySelectorAll('.js-ended .pagination-btn') as NodeListOf<HTMLElement>;

		const currentPage = eventEndedCurrentPage;
		const totalPage = eventEndedTotalPage;
		eventEndedCurrentPageGroup = Math.ceil(currentPage / eventEndedPagenationLen);
		eventEndedTotalPageGroup = Math.ceil(totalPage / eventEndedPagenationLen);

		const start = (eventEndedCurrentPageGroup - 1) * eventEndedPagenationLen;
		let end = eventEndedCurrentPageGroup * eventEndedPagenationLen;
		const lastPagenationNum = eventEndedPagenationLen * eventEndedTotalPageGroup - eventEndedTotalPage;

		if (eventEndedCurrentPageGroup == eventEndedTotalPageGroup) {
			end = totalPage;
		}

		for (let i = 0; i < len; i++) {
			const page = start + i + 1;
			const button = targetBtn[i + 1];

			if (!button) continue; // 버튼이 null이면 스킵

			button.innerText = String(page); // innerText 설정 시 문자열 변환

			// 현재 페이지 활성화
			if (currentPage - (eventEndedCurrentPageGroup - 1) * eventEndedPagenationLen === i + 1) {
				button.classList.add('active');
			}

			// 마지막 페이지 그룹
			if (eventEndedCurrentPageGroup === eventEndedTotalPageGroup && i >= len - lastPagenationNum) {
				button.classList.add('hidden');
			}

			// 클릭 이벤트 추가
			button.addEventListener('click', eventEndedClickPagenation);
		}

		const prevButton = document.querySelector('.js-ended .pagination-btn.btn-prev') as HTMLElement | null;
		const nextButton = document.querySelector('.js-ended .pagination-btn.btn-next') as HTMLElement | null;

		if (prevButton) {
			prevButton.addEventListener('click', eventEndedClickPagePrev);
		}

		if (nextButton) {
			nextButton.addEventListener('click', eventEndedClickPageNext);
		}
		eventEndedCheckBtnPrevNext(eventEndedCurrentPageGroup, eventEndedTotalPageGroup);
	};

	// 이전 버튼 클릭
	const eventEndedClickPagePrev = (e: MouseEvent) => {
		let pageGroup = eventEndedCurrentPageGroup - 1;
		if (pageGroup < 1) {
			pageGroup = 1;
		}
		eventEndedCurrentPageGroup = pageGroup;
		const page = eventEndedGetCurrentPage(
			eventEndedCurrentPageGroup,
			eventEndedTotalPageGroup,
			eventEndedTotalPage,
			false
		);
		eventEndedChangePage(page);
	};

	// 다음 버튼 클릭
	const eventEndedClickPageNext = (e: MouseEvent) => {
		let pageGroup = eventEndedCurrentPageGroup + 1;
		if (pageGroup > eventEndedTotalPageGroup) {
			pageGroup = eventEndedTotalPageGroup;
		}
		eventEndedCurrentPageGroup = pageGroup;
		const page = eventEndedGetCurrentPage(
			eventEndedCurrentPageGroup,
			eventEndedTotalPageGroup,
			eventEndedTotalPage,
			true
		);
		eventEndedChangePage(page);
	};

	// 페이지네이션 클릭
	const eventEndedClickPagenation = (e: MouseEvent) => {
		const page = (e.currentTarget as HTMLElement).innerText;
		eventEndedChangePage(page);
	};

	// 페이지 변경
	const eventEndedChangePage = (page: number | string) => {
		const oPage = eventOnGoingCurrentPage;
		const ePage = page;
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT}?oPage=${oPage}&ePage=${ePage}`);
	};

	// 이전 다음 버튼 활성 비활성 체크
	const eventEndedCheckBtnPrevNext = (currentPageGroup: number, totalPageGroup: number) => {
		const targetPrev = document.querySelector('.js-ended .pagination-btn.btn-prev');
		const targetNext = document.querySelector('.js-ended .pagination-btn.btn-next');

		// 이전 버튼
		if (currentPageGroup == 1) {
			eventEndedDisabledPagePrevNext(targetPrev);
		} else {
			eventEndedEnabledPagePrevNext(targetPrev);
		}

		// 다음 버튼
		if (currentPageGroup == totalPageGroup) {
			eventEndedDisabledPagePrevNext(targetNext);
		} else {
			eventEndedEnabledPagePrevNext(targetNext);
		}
	};

	// 이전 or 다음 버튼 활성화
	const eventEndedEnabledPagePrevNext = (target: Element | null) => {
		target?.removeAttribute('disabled');
	};

	// 이전 or 다음 버튼 비활성화
	const eventEndedDisabledPagePrevNext = (target: Element | null) => {
		target?.setAttribute('disabled', '');
	};

	// 페이지네이션 비활성화
	// const eventEndedDisabledPagenation = (target: Element | null) => {};

	// 현재 페이지 가져오기
	const eventEndedGetCurrentPage = (
		currentPageGroup: number,
		totalPageGroup: number,
		totalPage: number,
		isNext: boolean
	) => {
		const len = eventEndedPagenationLen;
		const start = (currentPageGroup - 1) * eventEndedPagenationLen;
		let end = currentPageGroup * eventEndedPagenationLen;
		let lastPage = 0;

		if (currentPageGroup == totalPageGroup) {
			end = totalPage;
		}

		for (let i = 0; i < len; i++) {
			const page = start + i + 1;
			if (page <= end) {
				lastPage = page;
			}
		}

		const currentPage = isNext || isNext == undefined ? start + 1 : start + 1;
		return currentPage;
	};

	// 컨텐츠 보여주기
	const eventShowContents = () => {
		const bodyElement = document.querySelector('body');
		const eventElement = document.querySelector('.event') as HTMLElement | null;
		const footerElement = document.querySelector('.footer') as HTMLElement | null;

		if (bodyElement) {
			bodyElement.classList.remove('is-scroll-y'); // body 요소의 클래스 제거
		}

		if (eventElement) {
			eventElement.classList.remove('hidden'); // .event 요소의 클래스 제거
		}

		if (footerElement) {
			footerElement.classList.remove('hidden'); // .footer 요소의 클래스 제거
		}
	};

	useEffect(() => {
		eventInit();
	}, []);
};

export default useEvent;
